import { Injectable } from '@angular/core';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';

@Injectable({
  providedIn: 'root',
})
export class SyncfusionDropDownListPatchService {
  //TODO: Remove in migration. The patch is needed to skip the Syncfusion's mousedown listener when destroyed
  init() {
    const dropDownListPrototype = DropDownList.prototype as any;
    const syncfusionOnDocumentClick = dropDownListPrototype.onDocumentClick;

    dropDownListPrototype.onDocumentClick = function (event: MouseEvent) {
      const isDestroyed = !this.inputWrapper;
      if (isDestroyed) return;
      syncfusionOnDocumentClick.call(this, event);
    };
  }
}
